import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminMenu, AdminMenuService } from '../../services/admin-menu.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  adminMenus: AdminMenu[] = [];
  isMenuLoading = false;
  username: string = '';
  roleName: string = '';

  constructor(
    private adminMenuService: AdminMenuService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadUserInfo();
    this.loadAdminMenus();
  }

  loadUserInfo() {
    const payload = this.authService.getTokenPayload();
    console.log('Decoded JWT payload:', payload);
    if (payload) {
      // Extract username from JWT (try common field names)
      this.username = payload.name;
      
      // Extract role name from JWT (try common field names)
      this.roleName = payload.Role;
    }
  }

  getRoleNameById(roleId: number): string {
    const roleMap: { [key: number]: string } = {
      1: 'Super Admin',
      2: 'Administrator',
      3: 'Editor',
      4: 'Viewer'
    };
    return roleMap[roleId] || 'User';
  }

  loadAdminMenus() {
    const roleId = this.authService.getRoleId();
    this.isMenuLoading = true;

    if (!roleId) {
      console.warn('HeaderComponent: no roleId found in JWT, skipping admin menu load');
      this.adminMenus = [];
      this.isMenuLoading = false;
      return;
    }

    this.adminMenuService.getByRole(roleId).subscribe({
      next: (menus) => {
        this.adminMenus = menus;
        console.log('Admin menus loaded:', this.adminMenus);
        this.isMenuLoading = false;
      },
      error: () => {
        this.adminMenus = [];
        this.isMenuLoading = false;
      }
    });
  }

  logout() {
    this.authService.logout();

    this.router.navigate(['/login']);
  }

}
